import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { SubSink } from 'subsink';
import { Router, RouterEvent } from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';


import { SwiperComponent } from 'swiper/angular';
import SwiperCore, { Autoplay, Pagination, Navigation, SwiperOptions } from 'swiper';
import { environment } from 'src/environments/environment';
import { ApiService } from 'src/app/services/api/api.service';
import { RegisterResetpassService } from 'src/app/services/register-resetpass/register-resetpass.service';

SwiperCore.use([Autoplay, Pagination, Navigation]);

@Component({
  selector: 'app-listing',
  templateUrl: './listing.page.html',
  styleUrls: ['./listing.page.scss'],
})
export class ListingPage implements OnInit {
  @ViewChild('swiper') swiper: SwiperComponent;

  subscription = new SubSink();
  roles: any;
  dropdownList = [];
  selectedItems = [];
  selectedChange = [];
  dropdownSettings: IDropdownSettings = {};
  videos: any = [];
  bucket_url: string = environment.s3_bucket_url;
  profilePlaceholder: string = '/assets/images/profile-placeholder.png';

  dropdownList2 = [];
  selectedItems2 = [];
  dropdownSettings2: IDropdownSettings = {};

  filter: string = '-1';
  base_url = environment.base_url;

  constructor(private apiService: ApiService, public router: Router, private accountTypes: RegisterResetpassService) { }

  ngOnInit() {
  }

  ionViewWillLeave() {
    this.subscription.unsubscribe();
  }

  async ionViewWillEnter(){
    await this.getUserAccountTypes();
    if(this.isUserLoggedIn()){
      this.apiService.get('users/users-listing').subscribe(
        (res: any[]) => {
          let archives = res['data'];
          this.setRecordData(archives);
        }
      )
    }else{
    await this.getListings();
    }
  }

  config: SwiperOptions = {
    pagination: { el: '.swiper-pagination', clickable: true },
    autoHeight: true,
    allowTouchMove: true,
    spaceBetween: 30,
    centeredSlides: false,
    navigation: true,
    autoplay: {
      delay: 6000,
      disableOnInteraction: true
    },
    breakpoints: {
      1024: {
        slidesPerView: 5
      },
      767: {
        slidesPerView: 'auto',
      }
    },
    loop: false,
  };

  onItemSelect(item: any) {
    this.selectedItems = item;
    console.log(this.selectedItems);
  }
  onSelectAll(items: any) {
    console.log(items);
  }

  getUserAccountTypes() {
    let items = [];
    this.subscription.sink = this.accountTypes.getAccountTypes().subscribe(
      (roles: any[]) => {
        this.roles = roles['data'];
        this.roles.forEach(element => {
          let item = {
            item_id: Number(element.id),
            item_text: element.account_type
          }
          items.push(item);
        });
        this.dropdownList = items;
      },
      (error) => console.log(error)
    );
  }

  getListings(){
    this.subscription.sink = this.accountTypes.getListingData().subscribe(
      (res: []) => {
        let archives = res['data'];
        this.setRecordData(archives);
      },
      (error) => console.log(error)
    );
  }
  setRecordData(archives){
    let records = [];
    archives.forEach(element => {
      if(element.id == 1)
        element['slug'] = 'band';
      else if(element.id == 2)
        element['slug'] = 'comedian';
      else if(element.id == 3)
        element['slug'] = 'food-truck';
      else if(element.id == 4)
        element['slug'] = 'user';
      else if(element.id == 5)
        element['slug'] = 'venue';
      records.push(element);
    });
    this.videos = records;
  }

  playVideo(id){
    this.router.navigate(['/video-detail/'+btoa(id) ]);
  }

  FilterArchive(event){
    this.filter = event.target.value;
  }
  goToProfile(account_type, id){
    let type = 'user';
    if(account_type == 1)
      type = 'band';
    else if(account_type == 2)
      type = 'comedian';
    else if(account_type == 3)
      type = 'food-truck';
    else if(account_type == 4)
      type = 'user';
    else if(account_type == 5)
      type = 'venue';
    else if(account_type == 6)
      type = 'comedy-club';
    else if(account_type == 7)
      type = 'artist';

    this.router.navigate([type + '/'+btoa(id)]);
  }

  isUserLoggedIn(){
    const storage_data = JSON.parse(localStorage.getItem('user_data'));
    if (storage_data !== undefined && storage_data !== null) {
      return true;
    }else{
      return false;
    }
  }

}
